<template>
  <div class="topic-footer">
    <div class="footer-container">
      <div class="footer-left">
        <div class="prev" v-if="topicInfo.topic_sort * 1 > 1" @click="onClickPrev">上一题</div>
      </div>
      <div class="footer-right">
        <div class="project-record" v-if="topicInfo.topic_type * 1 === 1" @click="projectShowHide">
          <div class="icon">
            <img src="@/assets/img/project-record.png" alt="">
          </div>
          <div class="text">项目记录（有效<span>{{ tableTotal }}</span>个）</div>
        </div>
        <div class="score">
          <div v-for="(item,index) in [0, 0.5, 1]" :key="index" class="score-item" :class="{active: score === item}" @click="scoreChange(item)">
            {{item}}分
          </div>
        </div>
        <div class="score-type">
          <div class="btn" @click="toggleMode">{{ isHand ? '恢复自动' : '手动打分'}}</div>
        </div>
        <div class="next" @click="onClickNext">下一题</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TopicFooter",
  props: {
    value: {
      type: [Number, String],
      default: ""
    },
    topicInfo: {
      type: Object,
      required: true
    },
    tableTotal: {
      type: Number,
      default: 0
    },
    isHand: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      score: ""
    };
  },
  watch: {
    value: {
      handler(val) {
        this.score = val;
      },
      immediate: true
    }
  },
  methods: {
    toggleMode() {
      this.$emit('update:isHand', !this.isHand);
      this.$emit('toggle-mode', !this.isHand);
    },
    scoreChange(score) {
      if (this.isHand) {
        this.$emit('input', score);
      }
    },
    projectShowHide() {
      if (this.topicInfo.topic_type * 1 === 1) {
        this.$emit('toggle-project');
      }
    },
    onClickPrev() {
      this.$emit('prev');
    },
    onClickNext() {
      this.$emit('next');
    }
  }
}
</script>

<style lang="less" scoped>
.footer-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.08rem;
  background: linear-gradient(165deg, #ff8927 0%, #ff6238 100%);
  box-shadow: 0px 0px .14rem 1px rgba(229, 92, 0, 0.55);
  border-radius: 0.42rem;
  border: 0.02rem solid #ffffff;
  .footer-right {
    display: flex;
  }

  .prev,
  .next {
    cursor: pointer;
    width: 0.9rem;
    height: 0.3rem;
    background: #ffe9cf;
    border-radius: 0.17rem;
    color: #5a3600;
    font-size: 0.14rem;
    text-align: center;
    line-height: 0.3rem;
  }

  .project-record {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 0.2rem;

    .icon {
      width: 0.14rem;
      height: 0.14rem;
      margin-right: 0.12rem;
      font-size: 0;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .text {
      font-size: 0.14rem;
      color: #fff;
      span {
        font-size: 0.18rem;
        font-weight: bold;
        color: #ffe371;
      }
    }
  }

  .score {
    display: flex;

    .score-item {
      width: 0.56rem;
      height: 0.3rem;
      margin-right: 0.15rem;
      font-size: 0.13rem;
      color: #fff;
      background: #ff813d;
      border-radius: 0.17rem;
      border: 1px solid #ffc292;
      text-align: center;
      line-height: 0.3rem;
      &:last-child {
        margin-right: 0;
      }
      &.active {
        color: #5a3600;
        background: #ffe371;
        border: none;
      }
    }
  }

  .score-type {
    margin: 0 0.2rem 0 0.2rem;

    .btn {
      width: 0.9rem;
      height: 0.3rem;
      background: #ffe371;
      border-radius: 0.17rem;
      font-size: 0.14rem;
      color: #5a3600;
      text-align: center;
      line-height: 0.3rem;
    }
  }
}
</style>